module.exports = __webpack_public_path__ + "static/media/elephant_bottom_s-min.54e4ebc7.jpg";